export enum TabsEnum {
    ALL,
    DELIVERY,
    TAKE_AWAY,
}
